import dispatch from "./dispatch";
const InfiniteScroll = require("infinite-scroll");

export default () => {
    if (document.querySelector(".js-paginator-holder")) {
        const paginationHolder = document.querySelector(".js-paginator-holder");
        const endOfContent = document.querySelector(".js-end-of-content");
        const perPage = paginationHolder.dataset.perpage;
        const nextPage = paginationHolder.dataset.nextlink;

        window.InfScroll = new InfiniteScroll(paginationHolder, {
            path: function setPath() {
                const link = nextPage;
                const current = (this.loadCount + 1) * perPage;
                return link.replace(/(start=)[^&]+/, "") + "start=" + current;
            },
            append: paginationHolder.dataset.items,
            checkLastPage: true,
            scrollThreshold: 300,  // Automatically load when 300px near the bottom
            debug: true,
            history: false,
            status: ".js-unit-loading",
        });

        window.InfScroll.on("append", function onAppend(response, path, items) {
            

            dispatch('INFINITE_LOADED');
        });

        window.InfScroll.on("request", function onRequest(response, path) {
            if (endOfContent) {
                endOfContent.style.display = "none";
            }
        });
    }
}
